{
  "calendar.tab": "التقويم",
  "calendar.today": "اليوم",
  "calendar.loadError": "تعذّر تحميل التقويم.",
  "calendar.truncated": "في هذه الفترة مهام أكثر مما يعرضه التقويم مرة واحدة. اختر شخصًا واحدًا أو انتقل إلى عرض الأسبوع لتراها كلها.",
  "calendar.caption": "{count, plural, zero {لا شيء مجدول} one {مهمة واحدة في التقويم} two {مهمتان في التقويم} few {# مهام في التقويم} many {# مهمة في التقويم} other {# مهمة في التقويم}}",
  "calendar.nav.previousMonth": "الشهر السابق",
  "calendar.nav.nextMonth": "الشهر التالي",
  "calendar.nav.previousWeek": "الأسبوع السابق",
  "calendar.nav.nextWeek": "الأسبوع التالي",
  "calendar.mode.label": "عرض التقويم",
  "calendar.mode.month": "شهر",
  "calendar.mode.week": "أسبوع",
  "calendar.filters.showDone": "إظهار المنجزة",
  "calendar.summary.label": "الفترة بالأرقام",
  "calendar.summary.none": "لا شيء",
  "calendar.summary.dueMonth": "مستحقة هذا الشهر",
  "calendar.summary.dueWeek": "مستحقة هذا الأسبوع",
  "calendar.summary.doneCaption": "{count, plural, zero {لم يُنجز شيء بعد} one {أُنجزت مهمة واحدة} two {أُنجزت مهمتان} few {أُنجزت # مهام} many {أُنجزت # مهمة} other {أُنجزت # مهمة}}",
  "calendar.summary.overdue": "متأخرة",
  "calendar.summary.milestones": "المحطات",
  "calendar.summary.undated": "بلا موعد بعد",
  "calendar.day.label": "{date}: {count, plural, zero {لا شيء} one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصرًا} other {# عنصر}}",
  "calendar.more": "{count, plural, zero {لا مزيد} one {+ واحدة أخرى} two {+ اثنتان أخريان} few {+# أخرى} many {+# أخرى} other {+# أخرى}}",
  "calendar.more.label": "عرض {count, plural, zero {لا شيء آخر} one {عنصر آخر} two {عنصرين آخرين} few {# عناصر أخرى} many {# عنصرًا آخر} other {# عنصر آخر}} يوم {date}",
  "calendar.chip.overdue": "متأخرة",
  "calendar.chip.milestone": "محطة، {range}، {status}",
  "calendar.chip.projected": "تتكرر في هذا اليوم، وتُنشأ المهمة قبله بأيام قليلة.",
  "calendar.span.range": "{start} – {end}",
  "calendar.week.label": "أسبوع {start}",
  "calendar.week.empty": "لا شيء مستحق هذا الأسبوع.",
  "calendar.agenda.label": "الأيام التي فيها عمل",
  "calendar.agenda.emptyTitle": "فترة هادئة",
  "calendar.agenda.emptyBody": "لا شيء مستحق في هذه الأيام.",
  "calendar.agenda.nothingToday": "لا شيء مستحق اليوم.",
  "calendar.unscheduled.title": "بلا موعد بعد",
  "calendar.unscheduled.hint": "اسحب مهمة إلى يوم لتحدد موعد تسليمها.",
  "calendar.unscheduled.emptyTitle": "كل المهام لها مواعيد",
  "calendar.unscheduled.emptyBody": "تظهر هنا المهام المفتوحة التي ليس لها موعد تسليم.",
  "calendar.legend.label": "معاني العلامات",
  "calendar.legend.task": "مهمة حسب حالتها",
  "calendar.legend.overdue": "متأخرة",
  "calendar.legend.milestone": "محطة",
  "calendar.legend.repeat": "تكرار قادم",
  "calendar.dnd.instructions": "لنقل مهمة إلى يوم آخر اضغط المسافة، واختر اليوم بالأسهم، ثم اضغط المسافة مرة أخرى. Escape يلغي النقل، وEnter يفتح المهمة.",
  "calendar.dnd.picked": "تم التقاط {title}. اختر يومًا بالأسهم.",
  "calendar.dnd.over": "{title}: {date}.",
  "calendar.dnd.dropped": "أصبح موعد {title} يوم {date}.",
  "calendar.dnd.droppedUnscheduled": "لم يعد لـ{title} موعد تسليم.",
  "calendar.dnd.cancelled": "بقيت {title} في مكانها.",
  "calendar.moved": "أصبح موعد «{title}» يوم {date}.",
  "calendar.movedUnscheduled": "لم يعد لـ«{title}» موعد تسليم.",
  "calendar.moveConflict": "عدّل أحدهم هذه المهمة للتو، والتقويم يعرض الآن أحدث نسخة.",
  "calendar.moveDenied": "لا يمكنك تغيير مواعيد هذه المهمة."
}
